if (!customElements.get("product-form")) {
  function alertMessage(message) {
    const alertDiv = document.createElement("div");
    alertDiv.textContent = message; // "Please select a scent for all options"
    alertDiv.style.position = "fixed";
    alertDiv.style.top = "20px";
    alertDiv.style.left = "50%";
    alertDiv.style.transform = "translateX(-50%)";
    alertDiv.style.backgroundColor = "#ff4444";
    alertDiv.style.color = "white";
    alertDiv.style.padding = "10px 20px";
    alertDiv.style.borderRadius = "5px";
    alertDiv.style.zIndex = "9999";
    alertDiv.style.boxShadow = "0 2px 10px rgba(0,0,0,0.2)";
    document.body.appendChild(alertDiv);

    // Remove after 3 seconds
    setTimeout(() => {
      document.body.removeChild(alertDiv);
    }, 3000);
  }

  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        const spinner = this.querySelector(".loading-overlay__spinner");
        if (spinner) spinner.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const quantityBreakContainer = document.querySelector(".quantity-break-container");
        // * quantity-break related logic
        const _selectedItem = document.querySelector(
          ".quantity-item--selected"
        );
        const selectElements = _selectedItem?.querySelectorAll(
          ".active-group select"
        );
        let shouldSelect = false;
        let hasSoldout = false;
        if (!!selectElements && selectElements.length > 0)
          selectElements.forEach((_select) => {
            const _value = _select.value;
            if (!_value) shouldSelect = true;
            if (_select.selectedOptions[0].disabled) hasSoldout = true;
          });

        if (!!quantityBreakContainer) {
          const formData = new FormData();

          const idInput = quantityBreakContainer.querySelector("input[name='id']");
          const propertyInputList = quantityBreakContainer.querySelectorAll("input.property");
          console.log("property input list", propertyInputList)

          formData.append("id", idInput.value);
          formData.append("quantity", 1);
          for (let j = 0; j < propertyInputList.length; j++) {
            const _index = j + 1;
            formData.append(`properties[Candle ${_index}]`, "");
            formData.append(`properties[Candle ${_index}]`, propertyInputList[j].value);
          }

          if (this.cart) {
            formData.append("sections", this.cart.getSectionsToRender().map((section) => section.id));
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (hasSoldout) {
                alertMessage("Please select non-soldout scents");
                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              }
              if (response.status) {
                if (shouldSelect) {
                  alertMessage("Please select a scent for all options");
                } else {
                  this.handleErrorMessage(response.description);
                }

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error) this.submitButton.removeAttribute("aria-disabled");
              const spinner = this.querySelector(".loading-overlay__spinner");

              if (spinner) spinner.classList.add("hidden");
              return;
            });
        } else {
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (hasSoldout) {
                alertMessage("Please select non-soldout scents");
                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              }
              if (response.status) {
                if (shouldSelect) {
                  alertMessage("Please select a scent for all options");
                } else {
                  this.handleErrorMessage(response.description);
                }

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error) this.submitButton.removeAttribute("aria-disabled");
              const spinner = this.querySelector(".loading-overlay__spinner");

              if (spinner) spinner.classList.add("hidden");
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
